<template>
  <div v-loading="loading" style="min-height: 800px;">

    <!--汇总-->
    <div class="common-form" style="border-bottom: 1px solid #DCDFE6;">今日分析</div>
    <Total style="min-height: 150px;" v-if="!loading"></Total>
    <!-- 商户统计 -->
    <SupAnalysis style="min-height: 480px;" v-if="!loading"></SupAnalysis>
    <!--交易统计-->
    <Transaction v-if="!loading"></Transaction>
  </div>
</template>

<script>
import StatisticsApi from "@/api/statistics.js";
import Total from "./part/Total.vue";
import Transaction from "./part/Transaction.vue";
import SupAnalysis from "./part/SupAnalysis.vue";
export default {
  components: {
    Total,
    Transaction,
    SupAnalysis
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*数据对象*/
      dataModel: {}
    };
  },
  provide: function() {
    return {
      dataModel: this.dataModel
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      StatisticsApi.getSupplierTotal({}, true)
        .then(res => {
          Object.assign(self.dataModel, res.data);
          self.loading = false;
        })
        .catch(error => {});
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/statistics/supplier/index.vue